import { CancelConfirmPanel, IconLibrary, ThriveIcon } from 'thrive-components';


interface IDeleteCommentPanelProps {
    title: string, 
    cancelButtonText: string, 
    cancelButtonAriaLabel: string, 
    confirmButtonAriaLabel: string, 
    confirmButtonText: string, 
    handleCancelClick:  (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void),
    handleConfirmClick:  (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void)
}

const DeleteCommentPanel = ({title, cancelButtonText, cancelButtonAriaLabel, confirmButtonAriaLabel, confirmButtonText, handleCancelClick, handleConfirmClick}: IDeleteCommentPanelProps) => {
    return (
        <div className="delete-comment-functionality-panel">
            <h1>
                <ThriveIcon iconName={IconLibrary.BIN} color='var(--thriveLightSlate)' sizeInPx='14' />
                {title}
            </h1>

            <CancelConfirmPanel 
                panelClassName={`cancel-confirm-modal-panel alert-style`} 
                cancelContent={cancelButtonText} 
                confirmContent={confirmButtonText}
                ariaLabelCancel={cancelButtonAriaLabel} 
                ariaLabelConfirm={confirmButtonAriaLabel} 
                onCancelClick={handleCancelClick} 
                onConfirmClick={handleConfirmClick} 
            />
        </div>
    );
};
export default DeleteCommentPanel